import { useEffect, useRef, useState } from "react";
import { useGraph } from "../graph/graph-context";
import { nodeLayoutAttribuesNames } from "../config/config";

function createItem(name, value) {
  return new window.ymaps.control.ListBoxItem({
    data: {
      content: name,
      overlay: value,
    },
    options: {
      selectOnClick: false,
    },
  });
}

export const ControlsLayout = ({ map, overlays, setOverlays }) => {
  const [items, setItems] = useState([]);
  const listBoxRef = useRef()
  const {graphConfig} = useGraph()

  useEffect(() => {
    const nodeAttribuesItems = graphConfig.nodeAttributes.map((it) => {
      return createItem(nodeLayoutAttribuesNames[it], it)
    })
    const items = [
      createItem("Дорожный граф", "roads"),
      createItem("Потоки", "flow"),
      createItem("Время проезда", "time"),
      new window.ymaps.control.ListBoxItem({
        options: {
          type: 'separator'
        }
      }), 
      ...nodeAttribuesItems
    ]

    const listBox = new window.ymaps.control.ListBox({
      items: items,
      data: {
        content: "Выберите слои",
      },
    });

    map.controls.remove(listBoxRef.current)
    listBoxRef.current = listBox
    map.controls.add(listBox, { float: "left" });
    setItems(items);
  }, [graphConfig]);

  useEffect(() => {
    items.forEach((it) => {
      if (overlays.includes(it.data.get("overlay"))) {
        it.select();
      } else {
        it.deselect();
      }
      it.events.types.click = undefined;
      it.events.add("click", function (e) {
        var item = e.get("target");
        const overlay = item.data.get("overlay");
        if (overlays.includes(overlay)) {
          setOverlays(overlays.filter((it) => it != overlay));
        } else {
          setOverlays([...overlays, overlay]);
        }
      });
    });
  }, [overlays, items]);
  return null;
};
